const zIndices = {
  /**
   *
   */
  boundingBox: 1000,
  dropdownPanel: 1001,
  pageManager: 1001,
  contextMenu: 1001,
  sideMenu: 1002,
  toolbarPopover: 1001,
  lineWidgetHandle: 1003,
  port: 1000,
  sideBar: 1005,
  toolbar: 1006,
  // should be higher than the toolbar as it's rendered above the toolbar
  accessibilityMenu: 1007,
  sideMenuSettings: 1007,
  navbar: 1008,
  fontMenu: 1008,
  // should be above all other content
  skipLinks: 1009,
  // Nothing can be on top of a temporary popover, including skipLinks.
  popOver: 2000,

  // Tooltip should be on top of popovers in the case that there are tooltips within
  // the popover content
  tooltip: 2001,

  // grid lines should be above all widgets on the page
  gridLines: 3000,
  // margin should be above all widgets on the page and on top of the grid lines
  margin: 3001,
};

export { zIndices };
